import { Button, Col, Form, Input, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { pickAFileSliceDispatch } from "../../Constants/ReduxConstants";

const FileName = () => {
    const currentFileName = useSelector((state: any) => state.pickAFile.fileName);

    const dispatch = useDispatch();

    let fileName = "";

    const onSubmit = (e: React.FormEvent<HTMLInputElement>) => {
        dispatch({ type: pickAFileSliceDispatch.setFileName, payload: fileName });
    }

    const onChange = (e: React.FormEvent<HTMLInputElement>) => {
        fileName = e.currentTarget.value;
    }

    return (
        <Form
            onFinish={onSubmit}
            preserve={false}
            initialValues={{
                ["File Name"]: currentFileName ? currentFileName : "No file selected"
            }}
        >
            <div style={{ 
                display: 'flex', 
                gap: '8px', 
                alignItems: 'flex-end'
            }}>
                <Form.Item 
                    rules={[{ required: true }]} 
                    name="File Name" 
                    label="File Name"
                    style={{ marginBottom: 0, minWidth: '300px' }}
                >
                    <Input 
                        id="fileName" 
                        placeholder='File Name' 
                        defaultValue={currentFileName} 
                        onChange={onChange} 
                    />
                </Form.Item>
                <Form.Item style={{ marginBottom: 0 }}>
                    <button 
                        type="reset"
                        style={{
                            padding: '4px 8px',
                            fontSize: '14px',
                            border: '1px solid var(--border-primary)',
                            background: 'var(--button-bg)',
                            color: 'var(--text-primary)',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            height: '32px',
                            minWidth: '60px'
                        }}
                        title="Reset File Name"
                    >
                        Reset
                    </button>
                </Form.Item>
                <Form.Item style={{ marginBottom: 0 }}>
                    <button 
                        type="submit"
                        style={{
                            padding: '4px 8px',
                            fontSize: '14px',
                            border: '1px solid var(--border-primary)',
                            background: 'var(--button-bg)',
                            color: 'var(--text-primary)',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            height: '32px',
                            minWidth: '60px'
                        }}
                        title="Submit File Name Change"
                    >
                        Submit
                    </button>
                </Form.Item>
            </div>
        </Form>
    )
}

export default FileName;